import React from 'react';
import FaceMatcherProvider from './useFaceMatcher';
import FaceMatcher from './FaceMatcher';

const FRmatcher = params => {
  return (
    <FaceMatcherProvider params={params}>
      <FaceMatcher />
    </FaceMatcherProvider>
  );
};

export default FRmatcher;
